"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApolloClient = void 0;
var tslib_1 = require("tslib");
var client_1 = require("@apollo/client");
var context_1 = require("@apollo/client/link/context");
var uuid_1 = require("uuid");
require("cross-fetch/polyfill");
// We must use a require() or WebPack will not compile this file as
// this package will be supplied at runtime
// eslint-disable-next-line @typescript-eslint/no-var-requires
var authPkg = require('@alinta-digital/myaccount-frontend-api-authentication');
// Create a new instance of the Client using the BFF Url
function createApolloClient(bffUrl, cache) {
    var httpLink = (0, client_1.createHttpLink)({
        uri: bffUrl,
        credentials: 'include',
    });
    // Sets the Context for the ApolloClient, this function will
    // be called everytime a request is made so getting the Auth Token
    // this way will allow it to always be up to date
    var authLink = (0, context_1.setContext)(function (_, _a) {
        var headers = _a.headers;
        var token = authPkg.getAuthenticator().getAuthToken();
        var xCorrelationId = (0, uuid_1.v4)();
        return {
            headers: tslib_1.__assign(tslib_1.__assign({}, headers), { authorization: token ? "Bearer ".concat(token) : '', 'x-correlation-id': xCorrelationId }),
        };
    });
    var client = new client_1.ApolloClient({
        link: authLink.concat(httpLink),
        cache: cache,
        credentials: 'include',
    });
    return client;
}
exports.createApolloClient = createApolloClient;
//# sourceMappingURL=client.js.map